// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const FacetFooter = props =>
    <footer>
        <button onClick={props.onReset}>
            <FormattedMessage id='RESET'/>
        </button>
        <button
            disabled={props.disabled}
            onClick={props.onApply}
        >
            <FormattedMessage id='APPLY'/>
        </button>
    </footer>;

FacetFooter.displayName = 'FacetFooter';
FacetFooter.propTypes = {
    disabled: PropTypes.bool.isRequired,
    onApply: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired
};

export default FacetFooter;



// WEBPACK FOOTER //
// ./src/shared/components/facets/facet-footer/index.js